export type OntologyApiNode = {
  id: string;
  label: string;
  hierarchicalParent?: string;
  hasHierarchicalChildren: boolean;
  numHierarchicalDescendants: number;
  geneCount?: number;
  cui?: string;
};

export type Gene = {
  id: string;
  symbol: string;
  fullName?: string;
};

export type OntologyNode = {
  id: string;
  label: string;
  parents: string[];
  children: string[];
  hasChildren: boolean;
  hiddenChildrenCount?: number;
  geneCount?: number;
  expanded: boolean;
  cui?: string;
  type?: 'disease' | 'gene' | 'show_more_genes' | 'show_related_diseases' | 'other_genes';
  meta?: { diseaseId?: string; geneId?: string; count?: number };
};

export const ONTOLOGY_MORE_NODE_PREFIX = '__more_';
export const SHOW_MORE_GENES_PREFIX = '__show_more_genes_';
export const SHOW_RELATED_DISEASES_PREFIX = '__show_related_diseases_';
export const OTHER_GENES_PREFIX = '__other_genes_';

export function isMoreNodeId(id: string): boolean {
  return id.startsWith(ONTOLOGY_MORE_NODE_PREFIX);
}

export function makeMoreNodeId(parentId: string): string {
  return `${ONTOLOGY_MORE_NODE_PREFIX}${parentId}`;
}

export function isShowMoreGenesNodeId(id: string): boolean {
  return id.startsWith(SHOW_MORE_GENES_PREFIX);
}

export function makeShowMoreGenesNodeId(diseaseId: string): string {
  return `${SHOW_MORE_GENES_PREFIX}${diseaseId}`;
}

export function isShowRelatedDiseasesNodeId(id: string): boolean {
  return id.startsWith(SHOW_RELATED_DISEASES_PREFIX);
}

export function makeShowRelatedDiseasesNodeId(geneId: string): string {
  return `${SHOW_RELATED_DISEASES_PREFIX}${geneId}`;
}

export function isOtherGenesNodeId(id: string): boolean {
  return id.startsWith(OTHER_GENES_PREFIX);
}

export function makeOtherGenesNodeId(diseaseId: string): string {
  return `${OTHER_GENES_PREFIX}${diseaseId}`;
}

export type SyntheticNodeType = 'show_more_genes' | 'show_related_diseases' | 'other_genes';

export type OntologyGraphState = {
  visibleGenesPerDisease: Map<string, number>;
  selectedGenes: Map<string, Set<string>>;
  expandedNodes: Set<string>;
  totalNodeCount: number;
};
